import { SpinnerContainer, SpinnerOverlay } from './loading.styles';

const Loading = () => (
  <SpinnerOverlay>
    <SpinnerContainer />
  </SpinnerOverlay>
);

export default Loading;